import { render } from "./TradePairToggle.vue?vue&type=template&id=36ef2def&scoped=true&ts=true"
import script from "./TradePairToggle.vue?vue&type=script&lang=ts"
export * from "./TradePairToggle.vue?vue&type=script&lang=ts"

import "./TradePairToggle.vue?vue&type=style&index=0&id=36ef2def&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ef2def"]])

export default __exports__